// extracted by mini-css-extract-plugin
export default {"wordListWrapper":"Player_wordListWrapper__8uSuh","fileName":"Player_fileName__YgTHL"};